export const UPLOADER__PATCH = 'UPLOADER__PATCH';
export const UPLOADER__UPLOAD = 'UPLOADER__UPLOAD';
export const UPLOADER__DELETE = 'UPLOADER__DELETE';
export const UPLOADER__CREATE_PLACEHOLDERS = 'UPLOADER__CREATE_PLACEHOLDERS';
